import React from "react";
import { motion } from "framer-motion";

/**
 * Animated circular score ring — used on Landing hero preview and Lesson Player.
 * Props: score (0-10), label, color (CSS var or hex), delay
 */
export default function ScoreRing({ score, label, color = "var(--accent)", delay = 0, size = 88 }) {
  const stroke = size <= 70 ? 4 : 5;
  const r = (size - stroke * 2) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 10) * c;
  const center = size / 2;
  return (
    <div className="flex flex-col items-center gap-2.5 py-1">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
          <circle
            cx={center}
            cy={center}
            r={r}
            fill="none"
            stroke="var(--bg-2)"
            strokeWidth={stroke}
          />
          <motion.circle
            cx={center}
            cy={center}
            r={r}
            fill="none"
            stroke={color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={c}
            initial={{ strokeDashoffset: c }}
            animate={{ strokeDashoffset: offset }}
            transition={{ delay, duration: 1.1, ease: [0.34, 1.56, 0.64, 1] }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <motion.span
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: delay + 0.3, duration: 0.4 }}
            className="font-display tabular-nums leading-none"
            style={{ fontSize: size * 0.42 }}
          >
            {score}
          </motion.span>
          <span className="font-mono text-[0.55rem] uppercase tracking-[0.14em] text-[var(--ink-3)] mt-0.5" style={{ fontSize: Math.max(8, size * 0.105) }}>
            /10
          </span>
        </div>
      </div>
      <span className="text-[0.78rem] font-medium text-[var(--ink-2)]">
        {label}
      </span>
    </div>
  );
}
